import '@crest/platform-web/styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.js';

const root = document.getElementById('root');
if (root === null) throw new Error('CREST web root element is missing.');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
